import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { SkinGroup } from '../api/types';
import { useAuth } from '../hooks/useAuth';
import { useCart } from '../hooks/useCart';
import { guardarDestino } from './ExigeLogin';
import { useCurrency } from '../hooks/useCurrency';
import { useI18n } from '../i18n';
import { pecasDoKit, linhaDoAnuncio } from '../lib/sacola';
import { itemDoAnuncio, trackAddToCart, trackLoginStart } from '../lib/tracking';

/**
 * Põe a faca e a luva do kit na sacola e leva o cliente até ela.
 *
 * O kit vira pedido pelo mesmo caminho de qualquer compra: a sacola mostra o
 * par com o preço de kit, o servidor refaz a conta ao fechar, e o pedido chega
 * ao painel. Mandar direto para o WhatsApp deixava o kit fora do painel e fora
 * do funil.
 */
export function BotaoKitNaSacola({
  knife,
  gloves,
}: {
  knife: { grupo: SkinGroup; exterior: string | null };
  gloves: { grupo: SkinGroup; exterior: string | null };
}) {
  const carrinho = useCart();
  const { rate } = useCurrency();
  const { loc } = useI18n();
  const navigate = useNavigate();
  const { user, loginUrl } = useAuth();
  const [buscando, setBuscando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  async function adicionar() {
    // A vitrine de kits é aberta, mas escolher a peça pede conta: os anúncios
    // só respondem para quem entrou. Volta para a aba Kits depois do login.
    if (!user) {
      guardarDestino('/kits');
      trackLoginStart();
      window.location.href = loginUrl;
      return;
    }
    setBuscando(true);
    setErro(null);
    try {
      const pecas = await pecasDoKit([knife, gloves]);
      for (const { anuncio } of pecas) {
        // Quem já tinha a peça na sacola não ganha outra: a sacola ignora o
        // anúncio repetido, e o evento só conta o que entrou de fato.
        if (!carrinho.linhas.some((l) => l.listingId === anuncio.commodityNo)) {
          trackAddToCart(itemDoAnuncio(anuncio));
        }
        carrinho.adicionar(
          linhaDoAnuncio(anuncio, {
            rate,
            exterior: anuncio.exterior ? loc(anuncio.exterior) : null,
          }),
        );
      }
      navigate('/sacola');
    } catch (e) {
      setErro(e instanceof Error ? e.message : 'Não consegui separar as peças deste kit.');
      setBuscando(false);
    }
  }

  return (
    <>
      <button type="button" className="btn primary" onClick={() => void adicionar()} disabled={buscando}>
        {buscando ? 'Separando as peças…' : user ? 'Adicionar kit à sacola' : 'Entrar e adicionar kit à sacola'}
      </button>
      {erro && <span className="kb-erro">{erro}</span>}
    </>
  );
}
